import axios from 'axios';
import queryString from 'query-string';

const jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

const defaultQueryParams = {};

const defaultApiHost = process.env.API || '';
const defaultApiProtocol = process.env.PROTOKOL || ''; // TODO: there is no default value cause of prod build (protocol and host are in "resource" string)

const fetchStruct = () => ({
    data: {},
    headers: {},
    params: {},
    host: defaultApiHost,
    protocol: defaultApiProtocol,
    extraParams: defaultQueryParams,
});

const METHOD_GET = 'get';
const METHOD_POST = 'post';
const METHOD_PUT = 'put';
const METHOD_DELETE = 'delete';

const request = (method = METHOD_GET) => (
    resource,
    {
        data = {},
        params = {},
        headers = {},
        protocol = defaultApiProtocol,
        host = defaultApiHost,
        extraParams = defaultQueryParams,
    } = fetchStruct(),
) => {
    const queryParams = Object.assign({}, extraParams, params);
    const url = `${protocol}${host}${resource}?${queryString.stringify(queryParams)}`;

    const config = {
        url,
        method,
        headers: Object.assign({}, jsonHeaders, headers),
        credentials: 'same-origin', // for zscaller
    };

    if (method !== METHOD_GET && method !== METHOD_DELETE) {
        config.data = config.headers['Content-Type'] === 'application/json' ? JSON.stringify(data) : data;
    }

    // Make a request for a user with a given ID
    return axios(config).then(result => result.data || null);
};

const get = request(METHOD_GET);
const put = request(METHOD_PUT);
const $delete = request(METHOD_DELETE);
const post = request(METHOD_POST);

const setLanguage = language => {
    if (typeof language !== 'string') {
        return;
    }

    defaultQueryParams.language = language;
};

const getHeaders = () => jsonHeaders;

export default {
    get,
    post,
    put,
    delete: $delete,
    getHeaders,
    setLanguage,
};
